/* global UNLEASH_URL */
/* global UNLEASH_CLIENT_KEY */

import "core-js";
import "regenerator-runtime/runtime";

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/de';
import '@formatjs/intl-pluralrules/dist/locale-data/fr';
import '@formatjs/intl-pluralrules/dist/locale-data/nl';
import '@formatjs/intl-pluralrules/dist/locale-data/es';
import '@formatjs/intl-pluralrules/dist/locale-data/it';
import '@formatjs/intl-pluralrules/dist/locale-data/pt';
import '@formatjs/intl-pluralrules/dist/locale-data/zh';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { create } from 'jss';
import {
  StylesProvider,
  createGenerateClassName,
  jssPreset,
} from '@material-ui/core/styles';

import { IntlProvider } from 'react-intl'; // test

import { LanguageProvider, LanguageConsumer } from './components/context/LanguageContext';
import { NotificationDialogProvider } from './components/context/NotificationDialogContext';
import { UserProvider, UserConsumer } from './components/context/UserContext';
import HelpdeskWidget from './components/content/HelpdeskWidget';

import flattenMessages from './utils/flattenMessages';
import { translations } from './intl/languages';
import { marathonFotoTranslations } from './intl/languages';

import App from './App';

import { customMuiTheme } from './customizedMuiTheme';
import FlagProviderWrapper from "./utils/flagProviderWrapper";
// redux
import { setupStore } from './store/store';
import { Provider as ReduxStoreProvider } from 'react-redux';

import { QueryRenderer, graphql } from 'react-relay';
import environment from './environment';

const generateClassName = createGenerateClassName();
const jss = create({
  ...jssPreset(),
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  insertionPoint: document.getElementById('jss-insertion-point'),
});

const featureFlagsClientConfig = {
  url: UNLEASH_URL,
  clientKey: UNLEASH_CLIENT_KEY,
  refreshInterval: 15,
  appName: 'sportograf_frontend',
};

const store = setupStore();
class AppContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BrowserRouter>
        <ReduxStoreProvider store={store}>
          <StylesProvider jss={jss} generateClassName={generateClassName}>
            <MuiThemeProvider theme={customMuiTheme}>
              <FlagProviderWrapper>
                <UserProvider>
                  <UserConsumer>
                    {({
                      isLoggedIn,
                      statsCookies,
                      socialCookies,
                      sportografWebCookies,
                      onCookiesChange,
                      isMarathonFoto,
                    }) => (
                      <LanguageProvider isMarathonFoto={isMarathonFoto}>
                        <LanguageConsumer>
                          {({ language, locale }) => (
                            <IntlProvider
                              locale={locale}
                              messages={flattenMessages(
                                translations[language],
                                marathonFotoTranslations[language],
                                isMarathonFoto
                              )}
                            >
                              <HelpdeskWidget>
                                <NotificationDialogProvider>
                                  <QueryRenderer
                                    environment={environment}
                                    query={graphql`
                                      query srcQuery {
                                        viewer {
                                          ...SportografNavigationBar_viewer
                                        }
                                      }
                                    `}
                                    variables={{ language }}
                                    render={({ error, props: relayProps }) => {
                                      if (error) return null;
                                      if (!relayProps) return null;
                                      return (
                                        <Route
                                          path={['/:language/event/:id/', '/:language']}
                                          render={(props) => (
                                            <App
                                              {...props}
                                              viewer={relayProps.viewer}
                                              language={language}
                                              isLoggedIn={isLoggedIn}
                                              statsCookies={Boolean(statsCookies)}
                                              socialCookies={Boolean(socialCookies)}
                                              sportografWebCookies={Boolean(sportografWebCookies)}
                                              onCookiesChange={onCookiesChange}
                                            />
                                          )}
                                        />
                                      );
                                    }}
                                  />
                                </NotificationDialogProvider>
                              </HelpdeskWidget>
                            </IntlProvider>
                          )}
                        </LanguageConsumer>
                      </LanguageProvider>
                    )}
                  </UserConsumer>
                </UserProvider>
              </FlagProviderWrapper>
            </MuiThemeProvider>
          </StylesProvider>
        </ReduxStoreProvider>
      </BrowserRouter>
    );
  }
}

ReactDOM.render(<AppContainer />, document.getElementById('app'));
